import API from '../../services/API';
import { createStructuredSelector } from 'reselect';
import { property } from 'lodash';

const normalizeResponse = ({ isOk, data, error }) => {
  if (isOk) {
    return data;
  } else {
    throw error;
  }
};

export function fetchReceipts(options) {
  return API.request({
    method: 'GET',
    url: '/receipts',
    params: options,
  }).then(normalizeResponse);
}

export function fetchFilters() {
  return API.request({
    method: 'GET',
    url: '/receipts/filters',
    mapper: createStructuredSelector({
      receiptCategories: property('receiptCategories'),
      years: property('years'),
    }),
  }).then(normalizeResponse);
}

export function fetchCategoriesDictionary() {
  return API.request({
    method: 'GET',
    url: '/receipts/categories',
  });
}

export function updateRecord(id, data) {
  return API.request({
    method: 'PUT',
    url: `/receipts/${id}`,
    data: data,
  }).then(normalizeResponse);
}

export function removeRecord(id) {
  return API.request({
    method: 'DELETE',
    url: `/receipts/${id}`,
  }).then(normalizeResponse);
}

export function unloadCsv() {
  return API.request({
    method: 'GET',
    url: '/receipts/xlsx',
    responseType: 'blob',
  });
}
